module.exports = __webpack_public_path__ + "media/images/event/event1-6af9a87463a1589aaa6e40a7bd409f60.png";